import produce from "immer";
import cloneDeep from "lodash/cloneDeep";

import IOperator from "interfaces/IOperator";
import { initialOperatorStoreState, IOperatorStoreState } from "store/state/operatorStoreState";
import Dictionary from "utils/dictionary";

import { ActionTypes, ActionTypesCollection } from "../actionTypes";

export default function operatorReducer(
  state: IOperatorStoreState = initialOperatorStoreState,
  action: ActionTypesCollection,
): IOperatorStoreState {
  switch (action.type) {
    case ActionTypes.FETCHED_OPERATORS: {
      const updatedOperators = cloneDeep(state.operators) ?? new Dictionary<IOperator[]>();

      updatedOperators[action.payload.customerId] = action.payload.operators;

      return produce(state, draftState => {
        draftState.operators = updatedOperators;
      });
    }
    default:
      return state;
  }
}
